module.exports = __webpack_public_path__ + "img/green-1-diamond-striped.868260ef.svg";